export default __webpack_public_path__ + "static/media/vacation.22a1a45c.svg";